import HeroSection from "../components/help/HeroSection.jsx"
import AgentCard from "../components/home/AgentCard.jsx";
import ContactForHelp from "../components/help/ContactForm.jsx"
import Footer from "../components/Footer.jsx";
import FAQAccordion from "../components/help/FaqSection.jsx";

const HelpPage = () => {
  return (
    <div>
      <HeroSection />
<FAQAccordion/>
      <ContactForHelp />
      <AgentCard />
      <Footer />
    </div>
  );
};

export default HelpPage;
